import React from "react";
import { toast } from "react-toastify";
import { connect } from "react-redux";
import { createStructuredSelector } from "reselect";
import { trackPromise } from "react-promise-tracker";

import { AuthUserContext, withAuthorization } from "../../Auth/Session";

import * as constantsTireCatalogue from "../../../constants/actions/TireCatalogues";
import * as APIS from "../../../constants/apis";
import { Modal } from "react-bootstrap";

function getTireCatalogue(id) {
  return (dispatch) => {
    return trackPromise(
      fetch(
        `${APIS.API_REST_TIRECATALOGUES.replace(
          "customer_id",
          localStorage.getItem("GlobalCustomerId")
        )}/${id}`,
        {
          headers: {
            Authorization: "Basic " + localStorage.getItem("firebaseAuthToken"),
            "Accept-language": localStorage.getItem("LanguageSelected"),
          },
        }
      )
        .then((response) => response.json())
        .then((json) => {
          dispatch(
            getTireCatalogueSuccess({
              catalogue: json,
            })
          );
        })
        .catch((error) => {
          toast.success(error.message);
        })
    );
  };
}

export function getTireCatalogueSuccess(json) {
  return {
    type: constantsTireCatalogue.GET_TICATALOGUE_SUCCESS,
    json,
  };
}

class TireCatalogueItem extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      openModal: false,
      image: "",
    };
  }
  componentDidMount() {
    const id = this.props.match.params.id;
    this.props.getTireCatalogue(id);
  }

  openImage() {
    return (
      <Modal
        show={this.state.openModal}
        dialogClassName="modal-sm-providers"
        onHide={() => this.setState({ openModal: false })}
      >
        <Modal.Header closeButton></Modal.Header>
        <Modal.Body>
          <div className="text-center">
            <img
              src={this.state.image}
              alt="example placeholder"
              style={{ width: "400px", height: "400px" }}
              className="text-center"
            />
          </div>
        </Modal.Body>
        <Modal.Footer></Modal.Footer>
      </Modal>
    );
  }

  render() {
    const { catalogue } = this.props;
    return (
      <AuthUserContext.Consumer>
        {(authUser) =>
          !!catalogue ? (
            <div className="container-fluid mt-100">
              <div className="d-flex justify-content-between">
                <h3>{this.props.t("tire-catalogue.tire-info")}</h3>
                {catalogue.image_url && (
                  <img
                    src={catalogue.image_url}
                    alt="example placeholder"
                    style={{
                      width: "200px",
                      height: "200px",
                      cursor: "pointer",
                    }}
                    onClick={() =>
                      this.setState({
                        openModal: true,
                        image: catalogue.image_url,
                      })
                    }
                    className="rounded-circle text-center"
                  />
                )}
              </div>
              <br />
              <div className="text-center v-scroll">
                <table className="table table-striped table-bordered table-sm mb-0">
                  <tbody>
                    <tr>
                      <th className="w-50">
                        {this.props.t("tire-catalogue.tire-item-1")}
                      </th>
                      <td className="w-50">{catalogue.marca}</td>
                    </tr>
                    <tr>
                      <th className="w-50">
                        {this.props.t("tire-catalogue.tire-item-2")}
                      </th>
                      <td className="w-50">{catalogue.modelo}</td>
                    </tr>
                    <tr>
                      <th className="w-50">
                        {this.props.t("tire-catalogue.tire-item-3")}
                      </th>
                      <td className="w-50">{catalogue.dimention}</td>
                    </tr>
                    <tr>
                      <th className="w-50">
                        {this.props.t("tire-catalogue.tire-item-6")}
                      </th>
                      <td className="w-50">{catalogue.prof_original}</td>
                    </tr>
                    <tr>
                      <th className="w-50">
                        {this.props.t("tire-catalogue.tire-item-7")}
                      </th>
                      <td className="w-50">{catalogue.prof_minima}</td>
                    </tr>
                    <tr>
                      <th className="w-50">
                        {this.props.t("tire-catalogue.tire-item-10")}
                      </th>
                      <td className="w-50">{catalogue.precio}</td>
                    </tr>
                    <tr>
                      <th className="w-50">
                        {this.props.t("tire-catalogue.tire-item-11")}
                      </th>
                      <td className="w-50">{catalogue.distribuidor}</td>
                    </tr>
                    <tr>
                      <th className="w-50">
                        {this.props.t("tire-catalogue.tire-item-8")}
                      </th>
                      <td className="w-50">{catalogue.presion_minima}</td>
                    </tr>
                    <tr>
                      <th className="w-50">
                        {this.props.t("tire-catalogue.tire-item-9")}
                      </th>
                      <td className="w-50">{catalogue.presion_maxima}</td>
                    </tr>
                    <tr>
                      <th className="w-50">
                        {this.props.t("tire-catalogue.tire-item-12")}
                      </th>
                      <td className="w-50">{catalogue.costo_milimetraje}</td>
                    </tr>
                    <tr>
                      <th className="w-50">Max Presión inflado</th>
                      <td className="w-50">
                        {catalogue.max_inflation_pressure}
                      </td>
                    </tr>
                    <tr>
                      <th className="w-50">Lonas</th>
                      <td className="w-50">{catalogue.tarps}</td>
                    </tr>
                    <tr>
                      <th className="w-50">Capacidad de carga (Kg)</th>
                      <td className="w-50">{catalogue.loading_capacity}</td>
                    </tr>
                    <tr>
                      <th className="w-50">Índice de carga</th>
                      <td className="w-50">{catalogue.load_index}</td>
                    </tr>
                    <tr>
                      <th className="w-50">Índice de velocidad (código)</th>
                      <td className="w-50">{catalogue.speed_index_code}</td>
                    </tr>
                    <tr>
                      <th className="w-50">Velocidad máxima</th>
                      <td className="w-50">{catalogue.max_speed}</td>
                    </tr>
                    <tr>
                      <th className="w-50">Temperatura (código)</th>
                      <td className="w-50">{catalogue.temperature_code}</td>
                    </tr>
                    <tr>
                      <th className="w-50">Temperatura max</th>
                      <td className="w-50">{catalogue.temperature_max}</td>
                    </tr>
                    <tr>
                      <th className="w-50">Diseño aplicación</th>
                      <td className="w-50">{catalogue.app_design}</td>
                    </tr>
                    <tr>
                      <th className="w-50">Resistencia al desgaste</th>
                      <td className="w-50">{catalogue.wear_resistance}</td>
                    </tr>
                    <tr>
                      <th className="w-50">¿Regrabable?</th>
                      <td className="w-50">{catalogue.rewritable}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              {this.state.openModal && this.openImage()}
            </div>
          ) : null
        }
      </AuthUserContext.Consumer>
    );
  }
}

const structuredSelector = createStructuredSelector({
  catalogue: (state) => state.catalogue,
});

const mapDispatchToProps = { getTireCatalogue };

const condition = (authUser) => !!authUser;

export default withAuthorization(condition)(
  connect(structuredSelector, mapDispatchToProps)(TireCatalogueItem)
);
